import { FieldType, RequestType, RoutingType } from "@secure-caseworker/shared";
import { FormTemplateData } from "../../RequestTemplates/RequestTemplateEditor";
import { BrowserPdfDocument } from "../../../contexts/PdfManagementContext";

export type FormattedOneOffTemplate = {
  organization_id: string;
  type: RequestType;
  title: string;
  description?: string;
  instructions?: string;
  routing?: RoutingType;
  form_fields?: Array<{
    key: string;
    label: string;
    field_type: FieldType;
    required: boolean;
    options?: string[] | Record<string, unknown>;
    order: number;
  }>;
  signature_signers?: Array<{
    key: string;
    label: string;
    signing_order?: number | null;
    required: boolean;
  }>;
  pdfDocuments?: BrowserPdfDocument[];
};

const formatOneOffTemplate = (
  orgId: string,
  oneOffTemplateData: FormTemplateData | null,
): FormattedOneOffTemplate => {
  if (!oneOffTemplateData) {
    throw new Error("One-off template data is missing");
  }

  return {
    organization_id: orgId,
    type: oneOffTemplateData.type as RequestType,
    title: oneOffTemplateData.title,
    description: oneOffTemplateData.description,
    instructions: oneOffTemplateData.instructions,
    routing: oneOffTemplateData.routing as RoutingType | undefined,
    form_fields: oneOffTemplateData.fields?.map((f, idx) => ({
      key: f.id,
      label: f.label,
      field_type: f.field_type as FieldType,
      required: f.required,
      options: f.options || undefined,
      order: idx,
    })),
    signature_signers: oneOffTemplateData.signerRoles?.map((s) => ({
      key: s.key,
      label: s.label,
      signing_order: s.signing_order,
      required: s.required,
    })),
    // Include pdfDocuments for signature templates
    pdfDocuments: oneOffTemplateData.pdfDocuments,
  };
};

export default formatOneOffTemplate;
